import {
  DATE_AND_TIME_FORMAT_WITH_WEEKDAY,
  normalizeDateString,
} from "@/overlay/components/TimeSettingsButtons/formats";
import { dateTimeToTimeZoneFormat } from "@/time";
import { useLingui } from "@lingui/react";
import type { GuiTimeZone } from "@mm/metx-workbench.meteomatics.com";
import type { DateTime } from "luxon";
import { useMemo } from "react";

/**
 * Component to pretty print a `DateTime` object.
 */
export function DatetimeLabel(
  props: {
    datetime: DateTime;
    timezone: GuiTimeZone;
  } & React.HTMLAttributes<HTMLSpanElement>,
) {
  const { datetime, timezone, ...rest } = props;
  const { i18n } = useLingui();

  // Note `title` shows the ISO timestamp on hover
  const isoStr = useMemo(() => dateTimeToTimeZoneFormat(datetime, timezone), [datetime, timezone]);
  const timezonedDateTime = useMemo(() => datetime.setZone(timezone), [datetime, timezone]);

  return (
    <span data-testid={"datetime-label-formatted"} className="formatted-datetime" title={isoStr} {...rest}>
      {normalizeDateString(
        timezonedDateTime.setLocale(i18n.locale).toLocaleString(DATE_AND_TIME_FORMAT_WITH_WEEKDAY),
      ).replace(/ /g, "\u00a0")}
    </span>
  );
}
